import { PaymentSchedule } from "@app/models/PaymentSchedule";
import {
    Component,
    Inject,
    Input,
    OnInit,
} from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: "app-payment-schedule",
    template: require("./payment-schedule.component.html"),
})
export class PaymentScheduleComponent implements OnInit {
    @Input() paymentSchedules: PaymentSchedule[];
    @Input() isPaymentMethodView: boolean;

    constructor(@Inject(Router) private router: Router) {}

    navigateToScheduleEditPayment(paymentScheduleId: string | number, frequency: string) {
        if(frequency === 'one-time') {
            this.router.navigateByUrl('/properties/oneTimeEdit/' + paymentScheduleId, {
                state: { scheduleId: paymentScheduleId } })
        } else {
            this.router.navigateByUrl("/properties/scheduleEdit/" + paymentScheduleId, {
                state: { scheduleId: paymentScheduleId } });
        }

    }

    ngOnInit(): void {}
}

